import { useEffect, useRef } from 'react';

import { isCurrentValueEqualToSingleOption } from '../utils/autoSelect';

import type { UseAutoSelectSingleFocusArea } from './types/useAutoSelectSingleFocusArea';

export const useAutoSelectSingleFocusArea: UseAutoSelectSingleFocusArea = (params) => {
  const { singleFocusAreaId, currentFocusAreaId, onSelectFocusArea } = params;

  const prevSingleFocusAreaIdRef = useRef<number | undefined>(undefined);
  const hasAutoSelectedForCurrentSingleRef = useRef(false);

  useEffect(() => {
    if (singleFocusAreaId == null) {
      prevSingleFocusAreaIdRef.current = undefined;
      hasAutoSelectedForCurrentSingleRef.current = false;
      return;
    }

    const singleOptionChanged = prevSingleFocusAreaIdRef.current !== singleFocusAreaId;

    if (singleOptionChanged) {
      prevSingleFocusAreaIdRef.current = singleFocusAreaId;
      hasAutoSelectedForCurrentSingleRef.current = false;
    }

    if (
      isCurrentValueEqualToSingleOption(currentFocusAreaId, singleFocusAreaId) ||
      hasAutoSelectedForCurrentSingleRef.current
    ) {
      return;
    }

    hasAutoSelectedForCurrentSingleRef.current = true;
    setTimeout(onSelectFocusArea, 0, singleFocusAreaId);
  }, [singleFocusAreaId, currentFocusAreaId]);
};
